<template>
  <div class="menus" v-if="userinfo!=''&userinfo.role>1">
    <div class="menus_body">
      <div class="menu" @click="mto(0,'/');"><div><van-icon name="wap-home-o" /></div><div>首页</div></div>
      <div v-if="userinfo.role==3" class="menu" @click="mto(1,'/employee');"> <div><van-icon name="user-o" /></div>
      <div >店员</div> </div>
      <div  v-if="userinfo.role==3" class="menu" @click="mto(2,'/members');">
        <div><van-icon name="user-circle-o" /></div>
        <div>用户</div> 
      </div>
      <div  v-if="userinfo.role==3" class="menu" @click="mto(3,'/cardlist/');"><div><van-icon name="coupon-o" /></div>
      <div >卡券</div> </div>
      <div class="menu" @click="mto(4,'/myfave');"><div><van-icon name="star-o" /></div>
      <div>收藏</div> </div>
      

      <div class="smoth" :style="'transform:translateX('+(acid*60)+'px)'"></div>
    </div>
  </div>
  
    <router-view v-slot="{Component}" >
      <keep-alive>
        <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive" />
    </router-view>
  
  <div class="bottomspace" v-if="userinfo!=''&userinfo.role>1"></div>

  <login @change="loginres" v-if="data.phone==''"></login>
</template>

<script>
// @ is an alias to /src
import login from './components/login.vue'
import { reactive,onMounted,ref,watch,toRefs } from 'vue';
import { useRouter } from 'vue-router';

import ajax from '@/assets/public.js'
import { Toast,Icon,Cell, CellGroup } from 'vant';

export default {
  name: 'HomeView',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    "login":login
  },
  setup(){
    var pusern=localStorage.getItem("pusern");

    if(!pusern){
      
      localStorage.setItem("backurl",window.location.href);
    

      window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ajax.appid+'&redirect_uri='+encodeURIComponent(ajax.oauth)+'&response_type=code&scope=snsapi_base&state=1#wechat_redirect';
      
    }
    const router=useRouter();

    const acid=ref('');
    const state=reactive({
      userinfo:'',
      sys:'',
      includeList:[],
      data:{}
    })
    // watch(()=>route,(newVal,oldVal)=>{
    //   if(newVal.meta.keepAlive&&state.includeList.indexOf(newVal.name)===-1){
    //     state.includeList.push(newVal.name)
    //   }
    // },{deep:true})
    onMounted(() => {
      acid.value=0;
      
      getdata()
    })
    const getdata=()=>{
      ajax.req({
        url: 'myinfo/',
        data: {},
      }).then(res => {
        if(res.error==1){
          // localStorage.clear();
          // window.location.reload();
        }else{
          state.userinfo=res.userinfo,
          state.data=res.data
        }
        
      });
    }
    function loginres(){
      state.data.phone=1;
    }
    function mto(id,v) {
      acid.value=id;
      linkto(v);
    }
    function linkto(v){
      router.push(v)
    }

    return {
      ...toRefs(state),
      loginres,
      linkto,
      mto,
      acid
    }
  }
}
</script>
